import { CreateListSortProps } from '../../utility/types';
import { api } from '../configs/axiosConfigs';

export const createListSort = async(requestBody: CreateListSortProps) => {
  // make sure the server responds to missing tittle with the correct error so it gets caught and responded to properly
  return await api.post('/list-sorts.json', requestBody);
};
